<script lang="ts">
  // components
  import TwoColumnCell from './TwoColumnCell.svelte';

  // utils
  import {
    isRunoff,
    isWinner,
    nameParts,
    partyClass,
  } from '../utils/race-helpers.js';

  // types
  import type { Choice } from '../types';

  /** Already in display order (orderedChoices) */
  export let candidates: Choice[];

  $:firstCandidate = candidates[0]
  $:secondCandidate = candidates[1]
  $:viewableCandidates = [firstCandidate, secondCandidate];

  export let districtNumber: number | null;
  export let isUncontested: boolean;
  export let eevp: number;
  export let totalVotes: number;
</script>

<tr class="contest__candidate-row">
  <th scope="row" class="text-center">
    {districtNumber}
  </th>
  {#each viewableCandidates as c, idx}
    {#if c}
      <TwoColumnCell
        last={nameParts(c).last}
        party={partyClass(c)}
        partyAbbr={c.party?.abbr ?? ''}
        votes={c.votes}
        totalVotes={totalVotes}
        isWinner={isWinner(c)}
        isRunoff={isRunoff(c)}
        {isUncontested}
        {idx}
        isIncumbent = {c.isIncumbent ? true : false}
      />
    {:else if idx == 1}
      <td>-</td>
    {/if}
  {/each}
  <td class="text-right">
    {#if isUncontested}
      Uncontested
    {:else}
    {eevp.toFixed(1)}<span class="candidate__pct-symbol">%</span>
    {/if}
  </td>
</tr>
